export default [
    {
        name: 'cadastro-waba-template',
        path: 'waba-template',
        redirect: 'waba-template/index',
        component: () => import(/* webpackChunkName: 'cadastro-waba-template' */ '@/views/cadastro/waba-template/Index'),
        children: [
            {
                meta: {title: 'Lista de templates do WhatsApp'},
                name: 'cadastro-waba-template-index',
                path: 'index',
                component: () => import(/* webpackChunkName: 'cadastro-waba-template' */ '@/views/cadastro/waba-template/List.vue'),
            },
        ],
    },
]
